import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "../store";
import CountDown from "./Cards/CountDown";
import toast, { Toaster } from "react-hot-toast";
import useApi from "../hooks/useApi";
import { ChangePage } from "../store/reducers/menu";
import { Button } from "@windmill/react-ui";
import useMediaQuery from "../hooks/useMediaQuery";

import "./P2PBetCard.css"
export default function P2PBetCard() {
  const { joinPool, getPools } = useApi();
  const dispatch = useDispatch();

  const { pool } = useSelector((store) => store.p2p);
  const { user, currency } = useSelector((store) => store.auth);

  const [stake, setStake] = useState(pool?.min);
  const [recvAmount, setRecvAmount] = useState(0)
  const [type, setType] = useState(1)
  const [odd, setOdd] = useState(0)
  const changeAmount = (amount) => {
    setStake(amount);
  }
  const isMobile = useMediaQuery('(max-width: 720px')

  useEffect(() => {
    if (type == 1) {
      console.log(((pool.spool - pool.spool * 0.05) / (pool.fpool + stake)), "here", (pool.spool - pool.spool * 0.05), (pool.fpool + stake), stake)
      const recv = ((pool.spool - pool.spool * 0.05) / (pool.fpool + stake)) * stake + stake
      setRecvAmount(Number(recv.toFixed(2)))
      setOdd(Number(recv / stake).toFixed(2))
    } else {
      const recv = ((pool.fpool - pool.fpool * 0.05) / (pool.spool + stake)) * stake + stake
      setRecvAmount(Number(recv.toFixed(2)))
      setOdd(Number(recv / stake).toFixed(2))
    }
  }, [stake, pool])

  const join = async (type) => {
    if (currency.symbol == 'USDT') {
      if (stake >= pool?.min && stake <= pool?.max) {
        await joinPool(stake, type, pool?._id).then(
          ({ data }) => {
            console.log(data);
            toast.success('You have joined successfully!')
            getPools()
            dispatch(ChangePage(""))
          },
          (err) => {
            console.log(err)
            toast.error(
              err.response.data,
            )
          }
        )
          .catch((error) => {
            console.log(error)
            toast.error(
              error.response.data,
            )
          });
      } else {
        toast.error(
          `Please input valid amount!`
        )
      }
    } else {
      toast.error(
        `You have to bet using USDT!`
      )
    }
  }

  return (
    <div
      style={{ marginTop: "0px" }}
      className={`bg-bcb_sidebar overflow-y-auto pt-4 ${isMobile ? 'p-4' : 'p-8'}  rounded-md`}
    >
      <p className="text-sm text-white text-center mb-4">Open Round</p>
      <div className="flex items-center justify-center space-x-6">
        <div className="flex items-center justify-center flex-col space-y-2 bg-background p-4 rounded-md">
          <p className="text-xs text-gray-300">Pool Creator</p>
          <img
            src={pool.user.avatar ? pool.user.avatar : `https://ui-avatars.com/api/?background=random&color=random&name=${pool?.user?.username}`}
            alt="andrew"
            className="rounded-lg h-15 w-15"
          />
          <p
            style={{ marginTop: "-12px" }}
            className="text-xs text-black bg-yellow-200 rounded-full px-3 "
          >
            {pool?.user?.username}
          </p>
        </div>
        <div
          style={{ fontFamily: "Geogrotesque Wide" }}
          className="bg-background rounded-full p-3 px-4 font-semibold"
        >
          VS
        </div>
        <div className="flex items-center justify-center flex-col space-y-2 bg-background p-4 rounded-md">
          <p className="text-xs text-gray-300">Rival</p>
          <img
            src={pool.user.avatar ? pool.user.avatar : `https://ui-avatars.com/api/?background=random&color=random&name=${pool?.user?.username}`}
            alt="andrew"
            className="rounded-lg  h-15 w-15"
          />
          <p
            style={{ marginTop: "-12px" }}
            className="text-xs text-black bg-yellow-200 rounded-full px-3 "
          >
            {user?.username}
          </p>
        </div>
      </div>
      <div
        style={{ marginTop: "1.5rem" }}
        className="bg-background p-4 rounded-md"
      >
        <div className="flex flex-row items-start justify-start space-x-4">
          <img
            src="https://icodrops.com/wp-content/uploads/2018/10/Ethereum-Logo.png"
            alt="eth"
            style={{ height: "3rem" }}
            className="rounded-lg object-contain"
          />
          <div>
            <p className="text-xs text-gray-500 mb-2">Pool Title</p>
            <p className="text-sm text-white">
              {pool?.content}
            </p>
          </div>
        </div>
        <div
          style={{ marginTop: "0.5rem" }}
          className="flex items-center justify-evenly flex-row bg-background rounded-md p-2"
        >

          <div>
            <p className="text-xs text-gray-500 ">Option 1</p>
            <p className="text-sm text-white mb-2">{pool?.option[1]}</p>
          </div>
          <div>
            <p className="text-xs text-gray-500 ">Option 2</p>
            <p className="text-sm text-white mb-2">{pool?.option[2]}</p>
          </div>
        </div>
      </div>

      <div
        style={{ marginTop: "0.5rem" }}
        className="bg-background rounded-md p-2"
      >
        <div className="flex items-center justify-evenly flex-row bg-background rounded-md p-2">
          <div className="flex flex-col items-center">
            <p className="text-xs text-gray-500 mb-2">Duration</p>
            <p className="text-sm text-white inline-flex items-center justify-center">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    fillRule="evenodd"
                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 6a.75.75 0 00-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 000-1.5h-3.75V6z"
                    clipRule="evenodd"
                  />
                </svg>
              </span>
              <CountDown date={pool?.expire} />
            </p>
          </div>
          <div className="flex flex-col items-center">
            <p className="text-xs text-gray-500 mb-2">First Pool Size</p>
            <p className="text-sm text-white inline-flex items-center justify-center">
              {" "}
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    fillRule="evenodd"
                    d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z"
                    clipRule="evenodd"
                  />
                </svg>
              </span>{" "}
              <span className="ml-2">{pool?.fpool} USDT</span>
            </p>
          </div>
          <div className="flex flex-col items-center">
            <p className="text-xs text-gray-500 mb-2">Second Pool Size</p>
            <p className="text-sm text-white inline-flex items-center justify-center">
              {" "}
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    fillRule="evenodd"
                    d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z"
                    clipRule="evenodd"
                  />
                </svg>
              </span>{" "}
              <span className="ml-2">{pool?.spool} USDT</span>
            </p>
          </div>
        </div>
        <div className="progress-container">
          <div className="progress-bar" style={{ width: `${((pool.fpool * 100) / (pool.fpool + pool.spool))}%` }} />
        </div>
        <select
          className="block appearance-none text-white w-full bg-background border border-black-300 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline mt-2"
          onChange={(e) => setType(e.target.value)}
        >
          <option value={1}>Option 1</option>
          <option value={2}>Option 2</option>
        </select>
        <div className={`${isMobile ? '' : 'flex'} items-center justify-between mt-2 ${isMobile ? '' : 'space-x-2'}`}>
          <div>
            <p className="text-xs text-gray-500 mb-2 ">{`(Min ${pool?.min} USDT Max ${pool?.max} USDT)`} </p>
            <input
              type="number"
              placeholder="5000"
              className="w-full text-white bg-stone-1000border border-stroke dark:border-stone-1000 py-[10px] pr-3 pl-5 text-dark-6 outline-none transition  border-r-0 disabled:cursor-default disabled:bg-gray-2 focus:border-primary dark:focus:ring-stone1000 dark:bg-stone-1000"
              value={stake}
              onChange={(e) => changeAmount(Number(e.target.value))}
            />
          </div>
          <div>
            <p className="text-xs text-gray-500 mb-2 ">Your Current Odd </p>
            <input
              type="text"
              placeholder="5000"
              className="w-full bg-stone-1000border border-stroke dark:border-stone-1000 py-[10px] pr-3 pl-5 text-dark-6 text-lg font-bold text-yellow-300 outline-none transition  border-r-0 disabled:cursor-default disabled:bg-gray-2 focus:border-primary dark:focus:ring-stone1000 dark:bg-stone-1000"
              value={`${odd}X`}
            />
          </div>
        </div>
      </div>
      <p className="text-xs text-gray-400">
        The anticipated return dynamically adjusts with each bet placed, and the ultimate return is determined by the final bet made prior to the declaration of the outcome.
      </p>
      <button
        onClick={() => join(type)}
        style={{ marginTop: "10px", width: '100%' }}
        className="btn-primary transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 "
      >
        Join
      </button>
    </div>
  );
}
